import { createContext } from 'react';

export const PredictionsContext = createContext();